import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

declare var jQuery: any;
declare var transPageOut: any;

@Injectable({
  providedIn: 'root'
})
export class MenuService {
  activePage: string = 'home';
  constructor(public router: Router) { }

  goToPage(page: string): void{
    this.activePage = page;
    console.log(page)
  }

  async routePage(url: string) {
    let me = this;
    if (url != '/home' && url != '' && url != '/index' && url != '/') {
      this.pageTransOut();
      setTimeout(function () {
        me.router.navigateByUrl(url);
      }, 1500);
    } else {
      me.router.navigateByUrl(url);
    }
  }

  pageTransOut() {
    transPageOut();
  }

  getActivePage() {
    return this.router.url;
  }
}
